import { observer } from 'mobx-react';
import { NotTranslated, T } from '../../../../../../Translations';
import FlashError from '../../../../../FlashMessage/FlashError';
import { LoadingError, whenExceededMaxUsers, getBadStatusErrorMessage } from '.././Types';

interface Props {
  state: LoadingError;
}

function LoadingErrorView({ state }: Props) {
  switch (state.error.kind) {
    case 'invalid-form-values':
      return whenExceededMaxUsers(state.error)
        .map((maxUsers) => (
          <FlashError>
            <T
              kind="You may allocate licenses to up to {{maxUsers}} users at a time."
              maxUsers={maxUsers}
            />
          </FlashError>
        ))
        .getOrElse(() => (
          <FlashError>
            <T kind="Error Loading." /> <NotTranslated text={state.error.kind} />
          </FlashError>
        ));
    case 'bad-status':
      return (
        <FlashError>
          <T kind={getBadStatusErrorMessage(state.error)} />
        </FlashError>
      );
    case 'bad-url':
    case 'timeout':
    case 'network-error':
    case 'bad-payload':
    case 'missing-application-id':
    case 'missing-api-compatibility':
    case 'missing-template-error':
    case 'missing-link-error':
    case 'missing-field-error':
    case 'invalid-url-error':
      return (
        <FlashError>
          <T kind="Error Loading." /> <NotTranslated text={state.error.kind} />
        </FlashError>
      );
  }
}

export default observer(LoadingErrorView);
